import { ComponentType, OverlayRef } from '@angular/cdk/overlay';
import { Directive, ElementRef, EventEmitter, HostListener, OnDestroy, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { ConnectedDialogPositions } from './connected-dialog-positions';
import { ConnectedDialogService } from './connected-dialog.service';

@Directive({
  selector: '[mstarConnectedDialog]',
  inputs: [
    'componentType: mstarConnectedDialog',
    'position: mstarConnectedDialogPosition ',
    'data: mstarConnectedDialogData'
  ]
})
export class ConnectedDialogDirective implements OnDestroy {
  
  overlayRef: OverlayRef;
  componentType!: ComponentType<any>;
  position: ConnectedDialogPositions = 'bottom';
  data!: any;

  @Output() onClosed = new EventEmitter<any>(); 
  closedSub: Subscription = this.connectedDialogService.onClosed$.subscribe(data => this.onClosed.emit(data));

  @HostListener('click', ['$event'])
  onClick(event: Event) {
    event.preventDefault();

    if (!this.connectedDialogService.overlayRef) {
      this.connectedDialogService.open(
        this.componentType,
        this.elementRef,
        this.position,
        this.data
      );

      this.connectedDialogService.overlayRef.backdropClick().subscribe(event => {
        this.closeDialog();
      });
    } else {
      this.closeDialog();
    }    
  }

  constructor(private connectedDialogService: ConnectedDialogService, private elementRef: ElementRef) { }

  closeDialog() {
    this.connectedDialogService.close();
    this.overlayRef = null;
  }

  ngOnDestroy(): void {
    this.closedSub.unsubscribe();
  }
}
